<template>
  <v-container fluid>
    <!-- ===== HEADER ===== -->
    <v-row align="center" class="mb-2" no-gutters>
      <v-col>
        <div class="text-h6 font-weight-bold">+ New Immigration Docket</div>
        <!-- <div class="text-caption grey--text text--darken-1">เพิ่มงานตรวจคนเข้าเมือง</div> -->
      </v-col>
      <v-col cols="auto">
        <v-btn outlined small @click="$router.push('/immigration-docket')"><v-icon left
            small>mdi-arrow-left</v-icon>Back</v-btn>
      </v-col>
    </v-row>

    <!-- ⭐ เพิ่มใหม่ — Tabs สลับระหว่าง Internal Work / Internal Timeline
         ตามแบบ incorporate-docket-add.vue module_name ที่ส่งให้ TimeLineOperations
         คือ "Immigration" -->
    <div class="mb-3">
      <v-tabs v-model="tabselect" color="#55638E" class="custom-tabs" style="border-bottom: 1px solid #E0E0E0;">
        <v-tab>Internal Work</v-tab>
        <v-tab>Internal Timeline</v-tab>
      </v-tabs>
    </div>

    <!-- ⭐ เพิ่มใหม่ — แท็บ Internal Timeline -->
    <v-card-text v-if="tabselect == 1" class="pa-0">
      <TimeLineOperations :showaddItem="form" :statuslist="statuslist" :reportlist="reportlist"
        :modeOperations="modeOperations" :timelineStatus="timelineStatus" :status_note="status_note"
        :visible_check="visible_check" :module_name="module_name" :timeline_case_id="timeline_case_id"
        @timelineStatus="timelineStatus = $event" :showReportInv="false" @requestStatus="handleRequestStatus"
        @update:status_note="status_note = $event" @update:visible_check="visible_check = $event" />
    </v-card-text>

    <!-- ⭐ แก้ไข — เดิมเป็น v-card เปล่า ๆ ครอบเนื้อหาเดิมทั้งหมด
         เปลี่ยนเป็น v-if="tabselect == 0" เพื่อสลับแท็บได้ เนื้อหาข้างในไม่ถูก
         แก้ไขแม้แต่จุดเดียว -->
    <v-card v-if="tabselect == 0" outlined class="pa-4">
      <!-- WORK TYPE BADGE -->
      <v-chip :color="form.workType ? 'green darken-1' : 'grey'" dark class="mb-4 font-weight-bold">
        <v-icon left small>mdi-tag</v-icon>{{ form.workType ? wtLabel : 'เลือก Work Type ด้านล่าง' }}
      </v-chip>

      <!-- ROW 1 -->
      <v-row dense>
        <v-col cols="12" md="4">
          <v-select v-model="form.workType" :items="workTypeItems" item-text="text" item-value="value"
            label="Work Type | ประเภทงาน *" outlined dense hide-details @change="onWorkTypeChange" />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="form.passport" label="Passport | เลขหนังสือเดินทาง *" placeholder="เลขหนังสือเดินทาง"
            color="red darken-1" outlined dense hide-details />
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="form.fileNo" :items="fileno_list" item-text="file_number" item-value="id"
            label="File No. | เลขที่แฟ้ม" placeholder="ค้นหา / เลือกแฟ้ม" outlined dense hide-details clearable
            @change="onFileNoChange" />
        </v-col>
      </v-row>

      <!-- ROW 2 -->
      <v-row dense class="mt-1">
        <v-col cols="12" md="4">
          <v-text-field v-model="form.principalApplicant" label="Principal Applicant | ชื่อผู้ยื่นคำขอหลัก *"
            placeholder="ชื่อ-นามสกุล" outlined dense hide-details />
        </v-col>
        <v-col cols="12" md="4">
          <v-select v-model="form.clientName" :items="clients" label="Client Name | ผู้ว่าจ้าง *" outlined dense
            hide-details />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="form.hostCompany" label="Host Company | บริษัทในประเทศไทย" placeholder="Auto จากแฟ้ม"
            outlined dense hide-details disabled background-color="grey lighten-4" />
        </v-col>
      </v-row>

      <!-- ROW 3 -->
      <v-row dense class="mt-1">
        <v-col cols="12" md="4">
          <v-select v-model="form.nationality" :items="nationalities" label="Nationality | สัญชาติ *" outlined dense
            hide-details />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="form.globalCaseNo" label="Global Case No. | เลขที่เคสจาก Global"
            placeholder="เลขที่เคส (ถ้ามี)" outlined dense hide-details />
        </v-col>
        <v-col cols="12" md="4" v-if="showCaseType">
          <v-select v-model="form.caseType" :items="caseTypes" label="Case Type | ประเภทเคส *" outlined dense
            hide-details />
        </v-col>
      </v-row>

      <v-divider class="my-5" />

      <!-- ===== DYNAMIC SECTIONS ===== -->
      <v-alert v-if="!cfg" dense text type="info" color="blue darken-1" class="mb-0">
        เลือก Work Type ด้านบนเพื่อแสดงฟิลด์ที่เกี่ยวข้อง
      </v-alert>

      <template v-else>
        <v-alert v-if="cfg.urgent" dense text color="orange darken-2" border="left" class="mb-3">
          ⚡ Urgent Work Permit Extension — ดำเนินการแบบเร่งด่วน
        </v-alert>

        <!-- VISA -->
        <v-card v-if="cfg.blocks.includes('visa')" outlined color="blue lighten-5" class="mb-3">
          <v-card-title class="sec-title blue--text text--darken-2">🛂 Visa | วีซ่า</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="3"><v-select v-model="form.visa.type" :items="visaTypes" item-text="text"
                  item-value="value" label="Visa Type | ประเภทวีซ่า" outlined dense hide-details /></v-col>
              <v-col cols="12" md="3"><date-field v-model="form.visa.issueDate"
                  label="Visa Issue Date | วันที่ออก" /></v-col>
              <v-col cols="12" md="3"><v-select v-model="form.visa.placeOfIssue" :items="visaPlaces"
                  label="Place of Issue | สถานที่ออก" outlined dense hide-details /></v-col>
              <v-col cols="12" md="3"><date-field v-model="form.visa.expiryDate"
                  label="Visa Expiry Date | วันที่หมดอายุ" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- WORK PERMIT -->
        <v-card v-if="cfg.blocks.includes('wp')" outlined color="green lighten-5" class="mb-3">
          <v-card-title class="sec-title green--text text--darken-2">🔑 Work Permit | ใบอนุญาตทำงาน</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4"><v-text-field v-model="form.wp.alienId" label="Alien ID | คนต่างด้าว (13 หลัก) *"
                  placeholder="0000000000000" maxlength="13" outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><v-text-field v-model="form.wp.number" label="Work Permit Number | เลขที่ใบอนุญาต"
                  outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><date-field v-model="form.wp.issueDate" label="Work Issue Date | วันที่ออก"
                  color="green" /></v-col>
              <v-col cols="12" md="8"><v-select v-model="form.wp.placeOfIssue" :items="wpPlaces"
                  label="Work Place of Issue | สถานที่ออก" outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><date-field v-model="form.wp.expiryDate" label="Work Expiry Date | วันที่หมดอายุ"
                  color="green" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- LTR -->
        <v-card v-if="cfg.blocks.includes('ltr')" outlined color="purple lighten-5" class="mb-3">
          <v-card-title class="sec-title purple--text text--darken-2">⭐ LTR | วีซ่าพำนักระยะยาว</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="3"><v-select v-model="form.ltr.category" :items="ltrCategories"
                  label="LTR Category | ประเภท LTR" outlined dense hide-details /></v-col>
              <v-col cols="12" md="3"><v-text-field v-model="form.ltr.reference" label="LTR Reference | เลขที่อ้างอิง"
                  outlined dense hide-details /></v-col>
              <v-col cols="12" md="3"><date-field v-model="form.ltr.issueDate" label="LTR Issue Date | วันที่อนุมัติ"
                  color="purple" /></v-col>
              <v-col cols="12" md="3"><date-field v-model="form.ltr.expiryDate" label="LTR Expiry Date | วันที่หมดอายุ"
                  color="purple" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- REPORT -->
        <v-card v-if="cfg.blocks.includes('report')" outlined color="blue lighten-5" class="mb-3">
          <v-card-title class="sec-title blue--text text--darken-2">📅 {{ cfg.reportDays === 90 ? '90-Day Report |
            รายงานตัว 90 วัน' : 'Annual Report | รายงานตัวประจำปี' }}</v-card-title>
          <v-card-text>
            <v-row dense align="center">
              <v-col cols="12" md="4"><date-field v-model="form.report.applicationDate"
                  label="Application Date | วันที่ยื่น *" @input="recalcDue" /></v-col>
              <v-col cols="12" md="4">
                <date-field v-model="form.report.dueDate" label="Due Date | วันที่ครบกำหนด" @input="recalcDue" />
                <!-- <v-text-field v-model="form.report.dueDate" label="Due Date | วันที่ครบกำหนด" readonly outlined dense
                  hide-details background-color="grey lighten-4" prepend-inner-icon="mdi-calendar-check"
                  :hint="'อัตโนมัติ +' + cfg.reportDays + ' วัน'" /> -->
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-caption font-weight-medium mb-1">Track | ติดตาม</div>
                <v-btn-toggle v-model="form.report.track" mandatory dense>
                  <v-btn small value="yes" :color="form.report.track === 'yes' ? 'green' : ''"
                    :dark="form.report.track === 'yes'">Yes</v-btn>
                  <v-btn small value="no">No</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- TOE -->
        <v-card v-if="cfg.blocks.includes('toe')" outlined color="orange lighten-5" class="mb-3">
          <v-card-title class="sec-title orange--text text--darken-3">📔 Transfer of Endorsement |
            โอนตราประทับวีซ่า</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6"><v-text-field v-model="form.toe.newPassport"
                  label="New Passport | หนังสือเดินทางใหม่ *" placeholder="เลขหนังสือเดินทางใหม่" color="red darken-1"
                  outlined dense hide-details hint="ระบบจะอัปเดต Passport ด้านบนอัตโนมัติ" persistent-hint
                  @input="form.passport = form.toe.newPassport" /></v-col>
              <v-col cols="12" md="6"><date-field v-model="form.toe.issueDate" label="Issue Date | วันที่ออกเอกสาร *"
                  color="orange" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- TAX -->
        <v-card v-if="cfg.blocks.includes('tax')" outlined color="orange lighten-5" class="mb-3">
          <v-card-title class="sec-title orange--text text--darken-3">🧾 Personal Income Tax Filing |
            ยื่นแบบภาษีเงินได้</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4"><v-select v-model="form.tax.taxType" :items="taxTypes" label="Tax Type | ภ.ง.ด."
                  outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><v-text-field v-model="form.tax.taxId" label="Tax ID | เลขผู้เสียภาษี"
                  placeholder="0000000000000" maxlength="13" outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><v-select v-model="form.tax.incomeType" :items="incomeTypes"
                  label="Type of Income | ประเภทเงินได้" outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><v-text-field v-model="form.tax.calendarYear" label="Calendar Year | ปีภาษี *"
                  placeholder="YYYY" maxlength="4" outlined dense hide-details /></v-col>
              <v-col cols="12" md="4"><date-field v-model="form.tax.filingDate" label="Filing Date | วันที่ยื่น *"
                  color="orange" /></v-col>
              <v-col cols="12" md="4"><date-field v-model="form.tax.issuanceDate" label="Issuance Date | วันที่ออก"
                  color="orange" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- SIMPLE DOC -->
        <v-card v-if="cfg.blocks.includes('simple')" outlined class="mb-3">
          <v-card-title class="sec-title grey--text text--darken-2">📄 {{ cfg.simpleLabel }}</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6"><date-field v-model="form.simple.issueDate"
                  label="Issue Date | วันที่ออกเอกสาร *" /></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- CANCELLATION -->
        <template v-if="cfg.blocks.includes('cancel')">
          <v-alert dense text color="red darken-1" border="left" class="mb-2">
            ⚠️ {{ cfg.cancelLabel }} — กรอกวันที่ยื่นและวันที่มีผลด้านล่าง
          </v-alert>
          <v-row dense class="mb-1">
            <v-col cols="12" md="6"><date-field v-model="form.cancel.submissionDate"
                label="Submission Date | วันที่ยื่นขอยกเลิก *" color="red" /></v-col>
            <v-col cols="12" md="6"><date-field v-model="form.cancel.effectiveDate"
                label="Effective Date | วันที่มีผลจริง *" color="red" /></v-col>
          </v-row>
        </template>
      </template>

      <!-- ===== ADDITIONAL APPLICANTS ===== -->
      <template v-if="showApplicants">
        <v-divider class="my-5" />
        <div class="text-subtitle-2 font-weight-bold mb-2">👨‍👩‍👧 Additional Applicants | ผู้ยื่นคำขอเพิ่มเติม</div>
        <v-alert dense text type="info" color="blue darken-1" class="mb-3">
          เพิ่มบุคคลอื่นในแฟ้มเดียวกัน ไม่ต้องกรอกผู้ยื่นคำขอหลักซ้ำ
        </v-alert>

        <v-card v-for="(ap, i) in applicants" :key="i" outlined class="pa-3 mb-3"
          :color="ap.status === 'cancelled' ? 'red lighten-5' : ''">
          <div class="d-flex justify-end">
            <v-btn icon x-small color="red" @click="removeApplicant(i)"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-row dense>
            <v-col cols="12" md="4"><v-select v-model="ap.relation" :items="relations" label="Relation to Principal"
                outlined dense hide-details /></v-col>
            <v-col cols="12" md="4"><v-text-field v-model="ap.name" label="Name | ชื่อ-นามสกุล" outlined dense
                hide-details /></v-col>
            <v-col cols="12" md="4"><v-select v-model="ap.nationality" :items="nationalities"
                label="Nationality | สัญชาติ" outlined dense hide-details /></v-col>
            <v-col cols="12" md="4"><v-select v-model="ap.visaType" :items="visaTypes" item-text="text"
                item-value="value" label="Visa Type" outlined dense hide-details /></v-col>
            <v-col cols="12" md="4"><date-field v-model="ap.visaIssue" label="Visa Issue Date" /></v-col>
            <v-col cols="12" md="4"><date-field v-model="ap.visaExpiry" label="Visa Expiry Date" /></v-col>
          </v-row>
          <div class="d-flex align-center mt-2" style="gap:10px;">
            <span class="text-caption font-weight-medium">Status:</span>
            <v-select v-model="ap.status" :items="applicantStatus" item-text="text" item-value="value" outlined dense
              hide-details style="max-width:220px;" />
          </div>
          <v-row v-if="ap.status === 'cancelled'" dense class="mt-2">
            <v-col cols="12" md="6"><date-field v-model="ap.submissionDate" label="Submission Date | วันที่ยื่นยกเลิก"
                color="red" /></v-col>
            <v-col cols="12" md="6"><date-field v-model="ap.effectiveDate" label="Effective Date | วันที่มีผล"
                color="red" /></v-col>
          </v-row>
        </v-card>

        <v-btn outlined block color="blue" class="mb-2" style="border-style:dashed;" @click="addApplicant">
          <v-icon left>mdi-plus</v-icon> Add Applicant / Dependant
        </v-btn>
      </template>

      <!-- ===== UPLOAD ===== -->
      <v-divider class="my-5" />
      <!-- <div class="text-subtitle-2 font-weight-bold mb-3">📎 Upload Document | อัปโหลดไฟล์</div>
      <div class="d-flex align-center flex-wrap" style="gap:12px;">
        <v-btn  depressed @click="docModal = true"
        :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"><v-icon left>mdi-cloud-upload</v-icon> UPLOAD</v-btn>
        <span class="text-caption red--text">Support .pdf files only *</span>
      </div>
      <div v-if="uploadedDocs.length" class="mt-3 d-flex flex-wrap" style="gap:6px;">
        <v-chip v-for="(d, i) in uploadedDocs" :key="i" small close @click:close="uploadedDocs.splice(i, 1)">
          <v-icon left small>mdi-file-pdf-box</v-icon>{{ d }}
        </v-chip>
      </div> -->
      <div class="text-subtitle-2 font-weight-bold mb-3">📎 Upload Document | อัปโหลดไฟล์</div>

      <input type="file" accept="application/pdf" multiple="multiple" @change="previewMultiImage" ref="filefile"
        style="display: none" />

      <div class="d-flex align-center flex-wrap" style="gap:12px;">
        <v-btn depressed :style="{ backgroundColor: '#254E58', color: 'white' }" @click="$refs.filefile.click()">
          <v-icon left>mdi-cloud-upload</v-icon> UPLOAD
        </v-btn>
        <span class="text-caption red--text">Support .pdf files only *</span>
      </div>

      <!-- รายการไฟล์ที่เลือก -->
      <div v-if="filename.length" class="mt-3 d-flex flex-wrap" style="gap:6px;">
        <v-chip v-for="(name, i) in filename" :key="i" small close @click="popuppreviewfile(i)"
          @click:close="popupdeletefile(i)">
          <v-icon left small>mdi-file-pdf-box</v-icon>{{ name }}
        </v-chip>
      </div>

      <!-- confirm delete file -->
      <v-dialog v-model="dialogDeletefile" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">ต้องการลบไฟล์นี้หรือไม่?</v-card-title>
          <v-card-actions class="justify-end">
            <v-btn text @click="closeDeletefile">Cancel</v-btn>
            <v-btn color="red" text @click="deleteItemConfirmfile">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== REMARK + STATUS ===== -->
      <v-row dense class="mt-4">
        <v-col cols="12" md="6"><v-text-field v-model="form.remark" label="Remark | หมายเหตุ"
            placeholder="หมายเหตุเพิ่มเติม" outlined dense hide-details /></v-col>
        <v-col cols="12" md="6"><v-select v-model="form.status" :items="statuslist" item-text="descriptions"
            item-value="module_id" label="Status *" outlined dense hide-details @change="sendToStatus" /></v-col>
      </v-row>
      <!-- ============ SECTION E: การเงิน / INVOICE ============ -->
      <v-divider class="mt-10"></v-divider>
      <div class="sec mt-6">
        <div class="sec-label">
          E · การเงิน &amp; สถานะ Invoice
        </div>

        <div class="invoice-box">
          <v-row>
            <v-col cols="12" md="4">
              <div class="field-label">เลขที่ใบเสนอราคา / Quotation ID</div>
              <v-autocomplete v-model="formQutations.salesOrderId" :items="salesOrderList" item-value="quotation_id"
                item-text="doc_no" placeholder="SO-69-0001" outlined dense hide-details="auto" background-color="white"
                clearable @change="onSelectSO" />
            </v-col>
            <v-col cols="12" md="4">
              <div class="field-label">Price</div>
              <v-text-field v-model="formQutations.price" type="number" outlined dense hide-details="auto"
                placeholder="฿" background-color="#f2f2f2" disabled />
            </v-col>

          </v-row>
          <v-row v-if="modeOperations == 'New' || (modeOperations == 'Edit' && invoiceList.length === 0)">
            <v-col cols="12" md="3">
              <div class="field-label">
                เลขที่ Invoice
                <v-tooltip top max-width="260">
                  <template #activator="{ on, attrs }">
                    <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                  </template>
                  <span>แนะนำเพิ่ม: บันทึกเลขบิลเมื่อออกแล้ว เพื่อตรวจสอบย้อนหลัง</span>
                </v-tooltip>

              </div>
              <v-text-field placeholder="INV-… (auto เมื่อออก)" disabled outlined dense hide-details="auto"
                background-color="#f2f2f2" />
            </v-col>
            <v-col cols="12" md="3">
              <div class="field-label">
                วันที่ออก Invoice
              </div>
              <!-- <v-text-field v-model="form.invoiceDate" type="date" outlined dense hide-details="auto"
                                    background-color="white" /> -->
              <v-menu v-model="invoiceMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="auto" disabled>
                <template #activator="{ on, attrs }">
                  <v-text-field placeholder="dd/mm/yyyy" readonly outlined dense hide-details="auto" v-bind="attrs"
                    v-on="on" append-icon="mdi-calendar" background-color="#f2f2f2" />
                </template>
                <v-date-picker v-model="formQutations.invoiceDate" no-title locale="th" @input="invoiceMenu = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <div class="field-label">
                วันครบกำหนดชำระ
              </div>
              <!-- <v-text-field v-model="form.dueDate" type="date" outlined dense hide-details="auto"
                                    background-color="white" /> -->
              <v-menu v-model="invoiceMenuPay" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="auto" disabled>
                <template #activator="{ on, attrs }">
                  <v-text-field placeholder="dd/mm/yyyy" readonly outlined dense hide-details="auto" v-bind="attrs"
                    v-on="on" append-icon="mdi-calendar" background-color="#f2f2f2" />
                </template>
                <v-date-picker v-model="formQutations.dueDate" no-title locale="th" @input="invoiceMenuPay = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <div class="field-label">
                Invoice Status
                <!-- <v-tooltip top max-width="260">
                    <template #activator="{ on, attrs }">
                      <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                    </template>
                    <span>หัวใจของโมดูล: ติดตามรอบบิลแบบเดียวกับ Immigration</span>
                  </v-tooltip> -->

              </div>
              <v-select placeholder="auto เมื่อออก" :items="invoiceStatusList" outlined dense hide-details="auto"
                background-color="#f2f2f2" disabled />
            </v-col>
          </v-row>
          <template v-if="modeOperations == 'Edit' && invoiceList.length > 0">
            <v-row v-for="(item, index) in invoiceList" :key="item.id">
              <v-col cols="12" md="3">
                <div class="field-label">
                  เลขที่ Invoice
                  <v-tooltip top max-width="260">
                    <template #activator="{ on, attrs }">
                      <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                    </template>
                    <span>แนะนำเพิ่ม: บันทึกเลขบิลเมื่อออกแล้ว เพื่อตรวจสอบย้อนหลัง</span>
                  </v-tooltip>
                </div>
                <v-text-field :value="item.invoice_display" placeholder="INV-… (auto เมื่อออก)" disabled outlined dense
                  hide-details="auto" background-color="#f2f2f2" />
              </v-col>
              <v-col cols="12" md="3">
                <div class="field-label">วันที่ออก Invoice</div>
                <v-text-field :value="item.created_at" disabled placeholder="dd/mm/yyyy" readonly outlined dense
                  hide-details="auto" append-icon="mdi-calendar" background-color="#f2f2f2" />
              </v-col>
              <v-col cols="12" md="3">
                <div class="field-label">วันครบกำหนดชำระ</div>
                <v-text-field :value="item.inv_date" disabled placeholder="dd/mm/yyyy" readonly outlined dense
                  hide-details="auto" append-icon="mdi-calendar" background-color="#f2f2f2" />
              </v-col>
              <v-col cols="12" md="2">
                <div class="field-label">
                  Invoice Status
                  <v-tooltip top max-width="260">
                    <template #activator="{ on, attrs }">
                      <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                    </template>
                    <span>หัวใจของโมดูล: ติดตามรอบบิลแบบเดียวกับ Immigration</span>
                  </v-tooltip>
                </div>
                <v-text-field :value="item.invoice_status" placeholder="auto เมื่อออก" outlined dense
                  hide-details="auto" background-color="#f2f2f2" disabled />
              </v-col>
              <v-col cols="12" md="1" class="d-flex align-center justify-center" style="margin-top: 24px;">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn icon color="primary" v-bind="attrs" v-on="on" @click="previewInvoice(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>ดูรายละเอียด</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </div>
      </div>
    </v-card>

    <!-- ===== ACTIONS ===== -->
    <div class="d-flex justify-end mt-4" style="gap:8px;">
      <v-btn outlined @click="goBack">CANCEL</v-btn>
      <v-btn color="primary" depressed @click="save('Save')"><v-icon left>mdi-content-save</v-icon> SAVE</v-btn>

      <v-btn color="#0A7EA5" @click="save('Payment')" :disabled="!formQutations.salesOrderId" style="color: #ffffff;">
        <v-icon left>mdi-content-save</v-icon>Request Payment
      </v-btn>
    </div>

    <!-- ===== DOCUMENT MODAL ===== -->
    <v-dialog v-model="docModal" max-width="560">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">📎 เลือกประเภทเอกสาร</v-card-title>
        <v-card-text>
          <div class="text-caption grey--text mb-2">เลือกประเภทเอกสารที่ต้องการอัปโหลด (รองรับ .pdf เท่านั้น)</div>
          <v-row dense>
            <v-col v-for="t in docTypes" :key="t" cols="6">
              <v-checkbox v-model="docSelected" :value="t" :label="t" dense hide-details class="mt-0" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="docModal = false">CANCEL</v-btn>
          <v-btn color="primary" depressed @click="confirmUpload">UPLOAD</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ⭐ เพิ่มใหม่ — Timeline Update Required dialog ตามแบบ
         incorporate-docket-add.vue (โครง UI เตรียมไว้ก่อน — เงื่อนไขเรียก
         ใช้จริงจะไปทำใน save() เอง ตามที่แจ้งไว้) -->
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card class="pa-10" style="border: 5px solid #e5e7eb;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="text-h4 font-weight-bold">Timeline Update Required</span>
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center" class="text-center">
            <span class="black--text text-body-1">
              Before saving this case, please update the internal timeline so the team can see the latest
              work
              status.
            </span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn depressed width="170" class="mr-3 " color="#0A7EA5" @click="deleteItemConfirm"
            style="border-radius: 20px; color: white; text-transform: none;">
            Update Timeline
          </v-btn>
          <v-btn depressed width="170" @click="closeDelete" color="red"
            style="border-radius: 20px; color: white; text-transform: none;">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- feedback -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3500" top right>
      {{ snackbar.text }}
      <template #action="{ attrs }"><v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn></template>
    </v-snackbar>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    <SuccessDialogPushpaymentIM :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
      :link="link" :querydata="querydata" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import DateField from "./DateField.vue";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import TimeLineOperations from "../timeline/TimeLineOperations.vue"; // ⭐ เพิ่มใหม่
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");
/* ---------- date helpers (DD/MM/YYYY <-> ISO) ---------- */
const pad = (n) => (n < 10 ? "0" : "") + n;
const dmyToISO = (d) => {
  if (!d) return "";
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(d).trim());
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
};
const isoToDMY = (iso) => {
  if (!iso) return "";
  const p = String(iso).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : "";
};
const addDaysDMY = (d, days) => {
  const iso = dmyToISO(d);
  if (!iso) return "";
  const dt = new Date(`${iso}T00:00:00`);
  dt.setDate(dt.getDate() + days);
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
};

/* ---------- work type config ---------- */
const WORK_TYPE_CONFIG = {
  "visa-renewal": { blocks: ["visa"] },
  "visa-cancel": { blocks: ["visa", "cancel"], cancelLabel: "Visa Cancellation" },
  "wp-new": { blocks: ["wp"] },
  "wp-renewal": { blocks: ["wp"] },
  "wp-cancel": { blocks: ["wp", "cancel"], cancelLabel: "Work Permit Cancellation" },
  "wp-urgent": { blocks: ["wp"], urgent: true },
  "vwp-renewal": { blocks: ["visa", "wp"] },
  "ltr-new": { blocks: ["ltr", "wp"] },
  "ltr-renewal": { blocks: ["ltr", "wp"] },
  "ltr-cancel": { blocks: ["ltr", "wp", "cancel"], cancelLabel: "LTR Cancellation" },
  pcc: { blocks: ["simple"], simpleLabel: "Police Clearance Certificate | ใบรับรองความประพฤติ" },
  legal: { blocks: ["simple"], simpleLabel: "Legalization | รับรองเอกสาร" },
  notarial: { blocks: ["simple"], simpleLabel: "Notarial Services | รับรองลายมือชื่อ/เอกสาร" },
  "90day": { blocks: ["report"], reportDays: 90 },
  annual: { blocks: ["report"], reportDays: 365 },
  toe: { blocks: ["toe"] },
  tax: { blocks: ["tax"] },
  other: { blocks: ["simple"], simpleLabel: "Other Immigration Service | งานบริการอื่น ๆ" },
};
const WT_LABELS = {
  "visa-renewal": "Visa Renewal | ต่ออายุ", "visa-cancel": "Visa Cancellation | ยกเลิกวีซ่า",
  "wp-new": "New Work Permit | ใบอนุญาตทำงานใหม่", "wp-renewal": "Work Permit Renewal | ต่ออายุ",
  "wp-cancel": "Work Permit Cancellation | ยกเลิก", "wp-urgent": "Urgent Work Permit Extension | ขยายเร่งด่วน",
  "vwp-renewal": "Visa & Work Permit Renewal | ต่ออายุ", "ltr-new": "New LTR | วีซ่าพำนักระยะยาวใหม่",
  "ltr-renewal": "LTR Renewal | ต่ออายุ", "ltr-cancel": "LTR Cancellation | ยกเลิก",
  pcc: "Police Clearance Certificate", legal: "Legalization | รับรองเอกสาร", notarial: "Notarial Services",
  "90day": "90-Day Report | รายงานตัว 90 วัน", annual: "Annual Report | รายงานตัวประจำปี",
  toe: "Transfer of Endorsement | โอนตราประทับวีซ่า", tax: "Personal Income Tax Filing | ยื่นแบบภาษีเงินได้",
  other: "Other Immigration Service | งานบริการอื่น ๆ",
};
const HAS_APPLICANTS = ["visa-renewal", "visa-cancel", "vwp-renewal", "ltr-new", "ltr-renewal", "ltr-cancel"];
const NO_CASE_TYPE = ["pcc", "legal", "notarial", "90day", "annual", "toe", "tax", "other"];
const WORK_TYPE_ITEMS = [
  { header: "Visa" },
  { text: "Visa Renewal | ต่ออายุ", value: "visa-renewal" },
  { text: "Visa Cancellation | ยกเลิกวีซ่า", value: "visa-cancel" },
  { divider: true }, { header: "Work Permit" },
  { text: "New Work Permit | ใบอนุญาตทำงานใหม่", value: "wp-new" },
  { text: "Work Permit Renewal | ต่ออายุ", value: "wp-renewal" },
  { text: "Work Permit Cancellation | ยกเลิก", value: "wp-cancel" },
  { text: "Urgent Work Permit Extension | ขยายเร่งด่วน", value: "wp-urgent" },
  { divider: true }, { header: "Visa + Work Permit" },
  { text: "Visa & Work Permit Renewal | ต่ออายุ", value: "vwp-renewal" },
  { divider: true }, { header: "LTR" },
  { text: "New LTR | วีซ่าพำนักระยะยาวใหม่", value: "ltr-new" },
  { text: "LTR Renewal | ต่ออายุ", value: "ltr-renewal" },
  { text: "LTR Cancellation | ยกเลิก", value: "ltr-cancel" },
  { divider: true }, { header: "Documents & Reports" },
  { text: "Police Clearance Certificate | ใบรับรองความประพฤติ", value: "pcc" },
  { text: "Legalization | รับรองเอกสาร", value: "legal" },
  { text: "Notarial Services | รับรองลายมือชื่อ/เอกสาร", value: "notarial" },
  { text: "90-Day Report | รายงานตัว 90 วัน", value: "90day" },
  { text: "Annual Report | รายงานตัวประจำปี", value: "annual" },
  { text: "Transfer of Endorsement | โอนตราประทับวีซ่า", value: "toe" },
  { text: "Personal Income Tax Filing | ยื่นแบบภาษีเงินได้", value: "tax" },
  { text: "Other Immigration Service | งานบริการอื่น ๆ", value: "other" },
];

const blankApplicant = () => ({
  relation: "Family/Dependant | Non-O", name: "", nationality: "", visaType: "",
  visaIssue: "", visaExpiry: "", status: "active", submissionDate: "", effectiveDate: "",
});
const blankForm = () => ({
  workType: "", passport: "", fileNo: null, principalApplicant: "", clientName: "", hostCompany: "",
  nationality: "", globalCaseNo: "", caseType: "", remark: "", status: "Ongoing | ดำเนินการอยู่",
  visa: { type: "", issueDate: "", placeOfIssue: "", expiryDate: "" },
  wp: { alienId: "", number: "", issueDate: "", placeOfIssue: "", expiryDate: "" },
  ltr: { category: "", reference: "", issueDate: "", expiryDate: "" },
  cancel: { submissionDate: "", effectiveDate: "" },
  report: { applicationDate: "", dueDate: "", track: "yes" },
  toe: { newPassport: "", issueDate: "" },
  tax: { taxType: "", taxId: "", incomeType: "", calendarYear: "", filingDate: "", issuanceDate: "" },
  simple: { issueDate: "" },
});

export default {
  name: "NewImmigrationDocket",
  components: {
    DateField,
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    TimeLineOperations, // ⭐ เพิ่มใหม่
  },
  data: () => ({
    querydata: "",
    filename: [],          // ชื่อไฟล์ที่แสดง
    image_list: [],        // File objects จริง → ใช้ append FormData
    getpreview_list: [],   // dataURL สำหรับ preview
    dialogDeletefile: false,
    indexdelete: -1,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    link: "",
    workTypeItems: WORK_TYPE_ITEMS,
    clients: ["Newland Chase PTE Ltd.", "Reckitt Benckiser (Thailand)", "Ford Services (Thailand)"],
    nationalities: ["British", "American", "German", "Japanese", "Indian", "Turkish", "Filipino"],
    caseTypes: [
      "NON-BOI | วีซ่าและใบอนุญาตทำงาน", "BOI | ภายใต้การส่งเสริมการลงทุน",
      "IEAT | ภายใต้การนิคมอุตสาหกรรม", "DMF | ภายใต้กรมการเชื้อเพลิงธรรมชาติ", "MEDIA | สื่อมวลชน",
    ],
    visaTypes: [
      { text: "Business/Work | Non-B", value: 1 },
      { text: "Family/Dependant | Non-O", value: 2 },
      { text: "LTR Entry", value: 3 },
      { text: "Smart Visa T", value: 4 },
    ],
    visaPlaces: ["MFA Bangkok", "Immigration Bureau Chaeng Wattana", "TIESC One Bangkok", "LTR Visa Unit TIESC", "Thai e-Visa Online"],
    wpPlaces: ["TIESC One Bangkok (BOI/IEAT/DMF/LTR/SMART)", "OFWA Din Daeng", "Bangkok Area Employment Office Area 1", "Provincial Employment Office Rayong"],
    ltrCategories: ["Wealthy Global Citizens", "Wealthy Pensioners", "Work-From-Thailand Professionals", "Highly-Skilled Professionals", "Dependants of the above categories"],
    relations: ["Family/Dependant | Non-O", "Spouse", "Child", "Parent"],
    applicantStatus: [{ text: "Active | ยังมีผลใช้งาน", value: "active" }, { text: "Cancelled | ยกเลิก", value: "cancelled" }],
    statuses: ["Ongoing | ดำเนินการอยู่", "Complete | ดำเนินการเสร็จสิ้น", "Request Payment"],
    taxTypes: ["ภ.ง.ด. 90", "ภ.ง.ด. 91", "ภ.ง.ด. 95"],
    incomeTypes: ["เงินเดือน", "ธุรกิจ", "รายได้อื่น ๆ"],
    docTypes: [
      "Passport (ID Page) | หน้าข้อมูล", "Visa Page | หน้าวีซ่า", "90-Day Report | รายงาน 90 วัน",
      "Marriage Cert. | ใบสมรส", "Birth Cert. | สูติบัตร", "Degree Cert. | ปริญญาบัตร", "Others | อื่น ๆ",
    ],
    fileno_list: [],
    form: blankForm(),
    applicants: [blankApplicant()],
    docModal: false,
    docSelected: [],
    uploadedDocs: [],
    snackbar: { show: false, text: "", color: "success" },
    customer_id: 0,

    // ⭐ เพิ่มใหม่ทั้งหมด — สำหรับ Internal Timeline tab (ตามแบบ
    // incorporate-docket-add.vue) module_name เป็น "Immigration" ตามที่ระบุ
    // modeOperations = "New" เพราะยังไม่มี docket เกิดขึ้นจนกว่าจะกด Save
    // (timeline_case_id เป็น 0 ไปก่อน — การผูก id จริงหลัง save ให้ไปจัดการเอง)
    tabselect: 0,
    timelineStatus: 0,
    status_note: "",
    visible_check: false,
    dialogDelete: false,
    timeline_case_id: 0,
    module_name: "Immigration",
    modeOperations: "New",
    reportlist: [],
    statuslist: [],
    //quotations
    formQutations: {
      salesOrderId: 0,
      price: 0
    },
    salesOrderList: [],
    invoiceList: [],
    invoiceMenu: false,
    invoiceMenuPay: false,
    invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
    quotationscheckstatus: '',
  }),

  computed: {
    cfg() { return this.form.workType ? WORK_TYPE_CONFIG[this.form.workType] : null; },
    wtLabel() { return WT_LABELS[this.form.workType] || this.form.workType; },
    showCaseType() { return !NO_CASE_TYPE.includes(this.form.workType); },
    showApplicants() { return HAS_APPLICANTS.includes(this.form.workType); },
  },

  /* ===== reused from old file (only mounted / data load) ===== */
  async mounted() {
    await this.loaddataSalesOrder()
    await this.loadfileno_list();
    await this.loaddatafile_no();
    await this.loaddataImmigrationStatus(); // ⭐ เพิ่ม — โหลด statuslist สำหรับ module "Immigration"
    this.sendToStatus(this.form.status);
    if (this.$hideLoader) this.$hideLoader();
  },
  beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },

  methods: {
    //quotations 
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(Number(localStorage.getItem(server.COMPANYID)));
        this.salesOrderList = res.data || [];

      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(value) {
      if (!value) {
        this.formQutations.price = "";
        return
      }
      // หา object ของ SO ที่เลือก
      const so = this.salesOrderList.find(item => item.quotation_id === value);
      if (so) {
        this.quotationscheckstatus = so.status;
        this.formQutations.price = Number(so.subtotal);
      }
    },
    //end quotattions
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
      );
      window.open(routeData.href, '_blank');
    },
    // ⭐ เพิ่มใหม่ทั้งบล็อกนี้ — สำหรับ Internal Timeline (ก็อปแบบมาจาก
    // incorporate-docket-add.vue) module_name = "Immigration"
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },
    handleRequestStatus(value) {
      this.form.status = value
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        (item) => item.module_id === value
      );
      if (selectedItem) {
        this.timelineStatus = Number(selectedItem.timeline_status_id);
      }
    },
    async loaddataImmigrationStatus() {
      try {
        const result = await api.getClientTimelineStatusCongFigByModule(
          "Immigration"
        );
        this.statuslist = (result.data || []).map((item) => ({
          ...item,
          module_id: item.module_id,
        }));
      } catch (error) {
        console.error("Error loading Immigration status config:", error);
      }
    },
    // ⭐ จบบล็อกเพิ่มใหม่สำหรับ Timeline

    async previewMultiImage(event) {
      const input = event.target;
      if (!input.files || input.files.length === 0) return;

      const files = Array.from(input.files);

      const promises = files.map((file) => {
        return new Promise((resolve) => {
          if (file.type === "application/pdf") {
            // กันชื่อซ้ำ: name.pdf → name-1.pdf, name-2.pdf ...
            let originalName = file.name || "file";
            let name = originalName;
            let counter = 1;
            while (this.filename.includes(name)) {
              const dotIndex = originalName.lastIndexOf(".");
              name = dotIndex !== -1
                ? `${originalName.substring(0, dotIndex)}-${counter}${originalName.substring(dotIndex)}`
                : `${originalName}-${counter}`;
              counter++;
            }
            const renamedFile = new File([file], name, { type: file.type });

            this.filename.push(name);
            this.image_list.push(renamedFile);

            const reader = new FileReader();
            reader.onload = (e) => {
              this.getpreview_list.push(e.target.result);
              resolve();
            };
            reader.readAsDataURL(renamedFile);
          } else {
            this.notify("รองรับเฉพาะไฟล์ .pdf เท่านั้น", "error");
            resolve();
          }
        });
      });

      await Promise.all(promises);
      input.value = ""; // เคลียร์ input ให้เลือกไฟล์เดิมซ้ำได้
    },

    popuppreviewfile(index) {
      const pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body>" +
        "<iframe width='100%' height='100%' src='" +
        this.getpreview_list[index] +
        "'></iframe></body></html>"
      );
    },

    popupdeletefile(index) {
      this.indexdelete = index;
      this.dialogDeletefile = true;
    },
    closeDeletefile() {
      this.indexdelete = -1;
      this.dialogDeletefile = false;
    },
    deleteItemConfirmfile() {
      this.filename.splice(this.indexdelete, 1);
      this.image_list.splice(this.indexdelete, 1);
      this.getpreview_list.splice(this.indexdelete, 1);
      this.closeDeletefile();
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async loadfileno_list() {
      const result = await api.getfile_numberim_principal_Company({
        params: { company_id: localStorage.getItem(server.COMPANYID) },
      });
      this.fileno_list = result.data;
    },
    async loaddatafile_no() {
      const routeFile = this.$route && this.$route.params ? this.$route.params.file_no : null;
      if (!routeFile) return;
      const x = this.fileno_list.find((f) => f.file_number == routeFile);
      if (x) { this.form.fileNo = x.id; this.onFileNoChange(x.id); }
    },
    onFileNoChange(id) {
      const x = this.fileno_list.find((f) => f.id === id);
      if (!x) return;
      this.form.clientName = x.client_name || this.form.clientName;
      this.form.hostCompany = x.company_name || "";
      this.form.principalApplicant = x.customer_name || this.form.principalApplicant;
      this.customer_id = x.customer_id || 0;
    },
    onWorkTypeChange() {
      this.recalcDue();
      if (this.showApplicants && this.applicants.length === 0) this.applicants = [blankApplicant()];
    },
    recalcDue() {
      this.form.report.dueDate =
        this.cfg && this.cfg.reportDays && this.form.report.applicationDate
          ? addDaysDMY(this.form.report.applicationDate, this.cfg.reportDays)
          : "";
    },
    addApplicant() { this.applicants.push(blankApplicant()); },
    removeApplicant(i) { this.applicants.splice(i, 1); },
    confirmUpload() {
      const docs = this.docSelected.map((d) => d.split(" | ")[0]);
      this.uploadedDocs = this.uploadedDocs.concat(docs);
      this.docSelected = [];
      this.docModal = false;
      this.notify(`อัปโหลดเอกสาร ${docs.length} รายการ`, "success");
    },
    notify(text, color = "success") { this.snackbar = { show: true, text, color }; },
    goBack() { if (this.$router) this.$router.push("/immigration-docket"); },
    // async save() {
    //   if (this.timelineStatus == 0 || this.status_note.trim() == "") {
    //     this.dialogDelete = true;
    //     return;
    //   }
    //   var main_id = 9999999;
    //   var dataadd_timeline = {

    //     timeline_status_id: Number(this.timelineStatus),
    //     case_id: Number(main_id),
    //     module_name: "Immigration",
    //     case_woker: Number(localStorage.getItem(server.USER_ID)),
    //     status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
    //     status_note: this.status_note.trim(),
    //     visibility: this.visible_check,
    //   }
    //   await api.creategetClientTimelineHistory(dataadd_timeline)
    //   try {
    //     const caseDetailResult = await api.getgetTimelineDataDetail({
    //       params: { module_name: this.module_name, case_id: Number(main_id) },
    //     });
    //     const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

    //     const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
    //       params: { module_name: this.module_name, case_id: Number(main_id) },
    //     });
    //     const timelineData = visibilityResult.data || [];

    //     caseInfo.status = timelineData[0]?.status || '';
    //     caseInfo.lastUpdated = timelineData[0]?.status_time || '';

    //     const latestUpdate = {
    //       message: timelineData[0]?.status_note || '',
    //       date: timelineData[0]?.status_time || '',
    //     };

    //     await PDFCaseProgress.createToPDF(
    //       {
    //         caseInfo,
    //         latestUpdate,
    //         timelineData,
    //         caseId: Number(main_id),
    //         moduleName: this.module_name,
    //       },
    //       { open: false }
    //     );
    //   } catch (pdfError) {
    //     console.error("PDF generation/upload failed:", pdfError);
    //     // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
    //   }
    // },
    // async save() {

    //   var mainid = 99999;
    //   var selectedModuleIds = [];
    //   // กรณี array อยู่แล้ว (เช่นมาจาก this.selectedModuleIds หรือ props ที่เป็น array)
    //   var moduleIds = Array.isArray(selectedModuleIds)
    //     ? [...selectedModuleIds]
    //     : [];

    //   // ยัด mainid เข้าไปในลิสต์ด้วย
    //   moduleIds.push(mainid);

    //   var dataPush = {
    //     customer_name_master: this.form.principalApplicant,
    //     module_id: moduleIds.join(","), // ส่งเป็น "1,2,3,99999"
    //     quotation_id: Number(this.formQutations.salesOrderId),
    //   }

    //   this.$router.push({
    //     path: `/new-free-invoice/0/invoice/D/${this.customer_id}/Immigration`,
    //     query: dataPush,
    //   });
    // },
    async save(mode) {
      const err = this.validateForm();
      if (err) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Failed", err, "text-h5 red--text text-center");
        return;
      }
      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }
      const isoDates = (obj) => {
        const out = {};
        Object.keys(obj).forEach((k) => {
          out[k] = /date$/i.test(k) ? (dmyToISO(obj[k]) || null) : obj[k];
        });
        return out;
      };

      // ---- รวม details ตาม blocks ของ work type ----
      const details = this.cfg
        ? this.cfg.blocks.reduce((a, b) => {
          if (this.form[b]) a[b] = isoDates(this.form[b]);
          return a;
        }, {})
        : {};

      const formData = new FormData();

      // ไฟล์
      this.image_list.forEach((f) => formData.append("file", f));
      formData.append("im_file", this.filename.join(",").replace(/\s/g, "_"));

      // ===== key ตรงชื่อคอลัมน์ im_docket =====
      formData.append("work_type", this.form.workType);
      formData.append("file_no", this.form.fileNo || 0);
      formData.append("client_name", this.form.clientName);
      formData.append("customer_id", this.customer_id || 0);       // ได้จาก onFileNoChange (ดูข้อ 3)
      formData.append("company_name", this.form.hostCompany);
      formData.append("passport", this.form.passport);
      formData.append("principal_applicant", this.form.principalApplicant);
      formData.append("nationality", this.form.nationality);
      formData.append("global_case_no", this.form.globalCaseNo);
      formData.append("case_type", this.showCaseType ? this.form.caseType : "");
      formData.append("status", this.form.status);
      formData.append("remark", this.form.remark);
      formData.append("details", JSON.stringify(details));         // → คอลัมน์ jsonb

      // คอลัมน์ date เดิม — ดึงจาก block ที่เกี่ยวข้อง
      const visaExp = dmyToISO(this.form.visa.expiryDate);
      const workExp = dmyToISO(this.form.wp.expiryDate) || dmyToISO(this.form.ltr.expiryDate);
      const dueDate = dmyToISO(this.form.report.dueDate);
      if (visaExp) formData.append("visa_expire_date", visaExp);
      if (workExp) formData.append("work_expire_date", workExp);
      if (dueDate) formData.append("due_date", dueDate);

      formData.append("company_id", localStorage.getItem(server.COMPANYID));
      formData.append("user_create", localStorage.getItem(server.USER_ID));
      formData.append("user_update", localStorage.getItem(server.USER_ID));
      formData.append("flag", this.form.status === "Request Payment" ? 1 : 0);
      formData.append("quotations_id", this.formQutations.salesOrderId);

      // applicants → ตารางลูก im_participant / im_docket_dependent (backend จัดการหลังได้ id)
      const participants = this.showApplicants
        ? this.applicants.filter(ap => ap.name).map(ap => ({
          type: ap.relation, name: ap.name, nationality: ap.nationality,
          visa_type: ap.visaType,
          visa_expire: dmyToISO(ap.visaExpiry) || null,
          status: ap.status,
        }))
        : [];
      formData.append("participants", JSON.stringify(participants));
      await this.$showLoader();
      const result = await api.addim_docket(formData);
      console.log(result);
      var main_id = result.data.id;

      if (result.status === 200 || result.status === 201) {
        try {
          if (this.quotationscheckstatus == "Submitted") {

            var dataupdateStatus = {
              status: "InProgress"
            }
            await api.updateQuotationsCore(Number(this.formQutations.salesOrderId), dataupdateStatus)
          }
        } catch (quotationsError) {
          console.log(quotationsError)
        }
        var dataadd_timeline = {

          timeline_status_id: Number(this.timelineStatus),
          case_id: Number(main_id),
          module_name: "Immigration",
          case_woker: Number(localStorage.getItem(server.USER_ID)),
          status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          status_note: this.status_note.trim(),
          visibility: this.visible_check,
        }
        await api.creategetClientTimelineHistory(dataadd_timeline)
        try {
          const caseDetailResult = await api.getgetTimelineDataDetail({
            params: { module_name: this.module_name, case_id: Number(main_id) },
          });
          const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

          const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
            params: { module_name: this.module_name, case_id: Number(main_id) },
          });
          const timelineData = visibilityResult.data || [];

          caseInfo.status = timelineData[0]?.status || '';
          caseInfo.lastUpdated = timelineData[0]?.status_time || '';

          const latestUpdate = {
            message: timelineData[0]?.status_note || '',
            date: timelineData[0]?.status_time || '',
          };

          await PDFCaseProgress.createToPDF(
            {
              caseInfo,
              latestUpdate,
              timelineData,
              caseId: Number(main_id),
              moduleName: this.module_name,
            },
            { open: false }
          );
          await this.$hideLoader()
        } catch (pdfError) {
          await this.$hideLoader()
          console.error("PDF generation/upload failed:", pdfError);
          // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
        }
        if (mode == "Save") {
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true, "save data", "save data success",
            "text-h5 green--text text-center", "/immigration-docket"
          );
          return;
        } else {

          var selectedModuleIds = [];
          // กรณี array อยู่แล้ว (เช่นมาจาก this.selectedModuleIds หรือ props ที่เป็น array)
          var moduleIds = Array.isArray(selectedModuleIds)
            ? [...selectedModuleIds]
            : [];

          // ยัด mainid เข้าไปในลิสต์ด้วย
          moduleIds.push(main_id);

          var dataPush = {
            customer_name_master: this.form.principalApplicant,
            module_id: moduleIds.join(","), // ส่งเป็น "1,2,3,99999"
            quotation_id: Number(this.formQutations.salesOrderId),
          }

          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${this.customer_id}/Immigration`,
            query: dataPush,
          });
        }
      } else {
        await this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true, "save data", "can't save data",
          "text-h5 red--text text-center"
        );
        return;
      }

      // this.notify(`บันทึก Docket สำเร็จ — ${this.wtLabel}`, "success");
    },
    validateForm() {
      const f = this.form;

      // ===== ฟิลด์หลัก (บังคับทุก work type) =====
      if (!f.workType) return "Please select Work Type | กรุณาเลือกประเภทงาน";
      if (!f.passport) return "Please enter Passport | กรุณากรอกเลขหนังสือเดินทาง";
      if (!f.principalApplicant) return "Please enter Principal Applicant | กรุณากรอกชื่อผู้ยื่นคำขอหลัก";
      if (!f.clientName) return "Please select Client Name | กรุณาเลือกผู้ว่าจ้าง";
      if (!f.nationality) return "Please select Nationality | กรุณาเลือกสัญชาติ";
      if (this.showCaseType && !f.caseType) return "Please select Case Type | กรุณาเลือกประเภทเคส";
      if (!f.status) return "Please select Status | กรุณาเลือกสถานะ";

      // ===== ฟิลด์ตาม block ของ work type ที่เลือก =====
      const blocks = this.cfg ? this.cfg.blocks : [];

      if (blocks.includes("wp")) {
        if (!f.wp.alienId) return "Please enter Alien ID | กรุณากรอกเลขคนต่างด้าว";
        if (!/^\d{13}$/.test(f.wp.alienId))
          return "Alien ID must be 13 digits | เลขคนต่างด้าวต้องเป็นตัวเลข 13 หลัก";
      }

      if (blocks.includes("report") && !f.report.applicationDate)
        return "Please enter Application Date | กรุณากรอกวันที่ยื่น";

      if (blocks.includes("toe")) {
        if (!f.toe.newPassport) return "Please enter New Passport | กรุณากรอกเลขหนังสือเดินทางใหม่";
        if (!f.toe.issueDate) return "Please enter Issue Date | กรุณากรอกวันที่ออกเอกสาร";
      }

      if (blocks.includes("tax")) {
        if (!f.tax.calendarYear) return "Please enter Calendar Year | กรุณากรอกปีภาษี";
        if (!/^\d{4}$/.test(f.tax.calendarYear))
          return "Calendar Year must be YYYY | ปีภาษีต้องเป็นตัวเลข 4 หลัก";
        if (!f.tax.filingDate) return "Please enter Filing Date | กรุณากรอกวันที่ยื่น";
      }

      if (blocks.includes("simple") && !f.simple.issueDate)
        return "Please enter Issue Date | กรุณากรอกวันที่ออกเอกสาร";

      if (blocks.includes("cancel")) {
        if (!f.cancel.submissionDate) return "Please enter Submission Date | กรุณากรอกวันที่ยื่นขอยกเลิก";
        if (!f.cancel.effectiveDate) return "Please enter Effective Date | กรุณากรอกวันที่มีผลจริง";
      }

      return null; // ผ่านหมด
    },
  },
};
</script>

<style scoped>
.sec-title {
  font-size: 0.9rem;
  font-weight: 700;
  padding: 10px 16px 6px;
}

.sec-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #1b7a99;
  font-weight: 700;
  margin-bottom: 14px;
}

.sec-label .hint {
  color: #6b7785;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

.invoice-box {
  background: #f7fafc;
  border: 1px solid #d8e6f0;
  border-radius: 8px;
  padding: 16px;
}

.field-label {
  font-size: 12.5px;
  color: #37424f;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 18px;
}

.field-label .hint {
  font-size: 11px;
  color: #6b7785;
}

.field-label .hint.danger {
  color: #c0392b;
}

.field-label .req {
  color: #c0392b;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #c47f00;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
}
</style>